import { useFormikContext } from "formik";
import {
  InputField,
  TextAreaField,
  VerticalForm,
} from "melco-shared-logic";
import { Button, Space, SaveIcon, FormItem, RangePicker } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { DisplayCouponsTypesDropDown } from "../DisplayCouponsTypesDropDown";
import { DisplayCouponsProductsDropDown } from "../DisplayCouponsProductsDropDown";
import { DisplayCouponsUsageTypesDropDown } from "../DisplayCouponsUsageTypesDropDown";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

const Right = styled(Space)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

type DisplayEditCouponFormProps = {
  CouponDetails: any;
};

export const DisplayEditCouponForm: React.FC<DisplayEditCouponFormProps> = ({
  CouponDetails,
}) => {
  const { t } = useTranslation();
  // const { isSubmitting, submitForm } = useFormikContext();
  const { isSubmitting, submitForm, values, setFieldValue, setValues } =
    useFormikContext<Record<string, any>>();

  const [startDate, setStartDate] = useState(values["start_date"]);
  const [endDate, setEndDate] = useState(values["end_date"])

  useEffect(() => {

    setValues({
      ...values,
      "start_date": startDate,
      "end_date": endDate
    })
  }, [startDate, endDate, setFieldValue])
  return (
    <>
      <div>
        <Right direction="vertical" size="small">
          <Button
            icon={<SaveIcon />}
            type="primary"
            // disabled={isSubmitting}
            loading={isSubmitting}
            onClick={() => {
              submitForm();
            }}
            style={{ marginBottom: "15px" }}
          >
            {t("coupons.actions.edit.button")}
          </Button>
        </Right>

        <VerticalForm>

          <InputField
            name="id"
            value={CouponDetails.id ? CouponDetails.id : ""}
            hidden
          />
          <InputField
            name="code"
            label={t("coupons.table.column.code")}
            value={CouponDetails.code ? CouponDetails.code : ""}
          />
          <DisplayCouponsTypesDropDown
            callbackFn={() => { }
            } />

          <InputField
            name="value"
            label={t("coupons.table.column.value")}
            placeholder={t("coupons.table.column.value")}
          />

          <TextAreaField
            name="description"
            label={t("coupons.table.column.description")}
            showCount
            maxLength={500}
            rows={4}
          />
          <DisplayCouponsProductsDropDown
            callbackFn={() => { }}

          />
          <DisplayCouponsUsageTypesDropDown />
          <InputField
            name="usage_count"
            label={t("coupons.table.column.usage_count")}
            placeholder={t("coupons.table.column.usage_count")}
          />
          <FormItem label="Date Range">
            <RangePicker
              style={{ width: "100%" }}
              format={"L"}
              onChange={(value) => {
                const serviceStartTimeStamp =
                  (value && value[0] && value[0].startOf("day").toDate()) ??
                  undefined;
                const serviceEndTimeStamp =
                  (value && value[1] && value[1].endOf("day").toDate()) ??
                  undefined;

                setStartDate(serviceStartTimeStamp)
                setEndDate(serviceEndTimeStamp)

              }}
              value={
                [
                  dayjs(startDate),
                  dayjs(endDate),
                ]
              }
              placeholder={[
                t("orders_list.filter.start_timestamp.placeholder"),
                t("orders_list.filter.end_timestamp.placeholder"),
              ]}
            />
          </FormItem>
        </VerticalForm>
      </div>
    </>
  );
};
